import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from 'vue';

export type Props = {
  root?: Element | null,
  rootMargin?: string,
}
export type Emits = {
  (e: 'bottom'): void,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DetectBottom',
  props: {
    root: { default: null },
    rootMargin: { default: '' }
  },
  emits: ["bottom"],
  setup(__props: any, { emit }) {

const props = __props;




const observer = ref<IntersectionObserver | null>(null);
const bottomEl = ref<Element | null>(null);

onMounted(() => {
  observer.value = new IntersectionObserver((elements) => {
    if (elements[0].isIntersecting) {
      emit('bottom');
    }
  }, props);

  observer.value.observe(bottomEl.value as Element);
});

onUnmounted(() => {
  observer.value?.disconnect(); // eslint-disable-line no-unused-expressions
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", {
      ref_key: "bottomEl",
      ref: bottomEl
    }, null, 512)
  ], 64))
}
}

})